// ✅ US Market How It Works - Thin Wrapper (DRY principle)
import HowItWorksPage from '../../sub/how-it-works';
import SEOHead from '../../../components/SEOHead';

export default function USHowItWorks() {
  return (
    <>
      <SEOHead
        title='How It Works | US Businesses | LB Websites'
        description='Discover how LB Websites builds fast, modern, and mobile-optimized websites for US businesses—from idea to live product with built-in CMS and support.'
        keywords='website development process USA, custom websites USA, web design USA, CMS, Next.js, mobile optimization, SEO'
        canonicalUrl='/us/sub/how-it-works'
        lang='en'
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/sub/how-it-works' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/sub/how-it-works' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/sub/kaip-veikia' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/sub/how-it-works' },
        ]}
      />

      {/* Reuse the main HowItWorks component - single source of truth for design */}
      <HowItWorksPage />
    </>
  );
}
